<div class="container">
  <div class="row mainRowDiv">
    <div *ngIf="env.env_name !== 'PROD'" class="ribbon"><a href="">UAT</a></div>
    <navbar></navbar>
    <div class="col-md-12" id="sessionTimeoutModal" class="hideClass">
      <div class="col-md-12 alert alert-warning customTimeout">
        <strong>Info!</strong>
        {{ "global.messages.info.sessiontimeout" | translate }}
      </div>
    </div>
    <router-outlet></router-outlet>
    <footer class="footer">
      <div class="col-md-12 footerMainDiv">
        <ul>
          <li class="noLeftmargin">
            <a><strong>©&nbsp;&nbsp;Allianz 2017</strong></a>
          </li>
          <li>
            <a
              href="https://www.allianz.co.id/layanan/investasi0/fund-allianz/fund-fact-sheet/dplk.html"
              target="_blank"
              >Fund Fact Sheet</a
            >
          </li>
          <li>
            <a
              href="https://www.allianz.co.id/kebijakan-privasi.html"
              target="_blank"
              >Privacy Policy</a
            >
          </li>
          <li>
            <a href="https://www.allianz.co.id/term-of-use.html" target="_blank"
              >Terms of Use</a
            >
          </li>
          <li class="midFooterLi"><a>&nbsp;&nbsp;&nbsp;</a></li>
          <li class="allianzCareLi">
            <a
              ><img
                class="allianzCareImg"
                src="assets/images/ppm/allianzcare.jpg"
            /></a>
          </li>
          <li><a>Allianz Care</a></li>
          <li class="floatRight">
            <a><strong>1500-136</strong></a>
          </li>
        </ul>
      </div>
    </footer>
  </div>
</div>
